/**
 * Vendor-specific Denver food, drink, catering, and service selections.
 *
 * Every visible option comes from a price currently published by the named
 * vendor. Source URLs are kept in the repository audit note rather than the
 * browser bundle.
 */

export const FOOD_CATEGORY_ORDER = [
  "Breakfast & Brunch",
  "Boxed Meals & Lunch",
  "Buffets & Plated Meals",
  "Food Stations & Specialty",
  "Appetizers & Receptions",
  "Snacks & Meeting Breaks",
  "Desserts & Sweets",
  "Non-Alcoholic Beverages",
  "Bar & Alcohol Service",
  "Staffing, Delivery & Rentals"
];

const VENDOR_SOURCES = {
  "mhc": [
    "Mile High Catering",
    "Mile High Catering published menus",
    "Most menus require 30 guests. Full service adds an 18% service charge, tax and staffing; drop-off adds 10% delivery."
  ],
  "three-tomatoes": [
    "Three Tomatoes Catering",
    "Three Tomatoes delivery catering menu",
    "Published prices exclude administration fee, tax, labor and transportation."
  ],
  "brothers": [
    "Brothers BBQ",
    "Brothers BBQ catering menu",
    "An 18% gratuity applies; groups of 200 or more require a direct quote."
  ],
  "etais": [
    "Etai's Catering",
    "Etai's box lunch catering menu",
    "Confirm current order minimums, delivery and fees before booking."
  ],
  "bagel-deli": [
    "The Bagel Deli",
    "The Bagel Deli party-tray menu",
    "The vendor states that prices are subject to change."
  ],
  "spice-room": [
    "Spice Room",
    "Spice Room catering packages",
    "Final pricing varies by headcount, menu selections and delivery distance."
  ],
  "tocabe": [
    "Tocabe",
    "Tocabe catering menu",
    "Requires 72 hours' notice; delivery and a 10% gratuity for 50+ guests are additional."
  ],
  "el-camino": [
    "El Camino Community Tavern",
    "El Camino catering and party menu",
    "Off-site catering is pickup only unless otherwise arranged."
  ],
  "risica": [
    "Risica",
    "Risica catering menu",
    "Confirm availability, delivery and service fees before booking."
  ]
};

const FOOD_OPTION_ROWS = [
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-continental-breakfast",
    "Continental breakfast",
    "Bagels, muffins, fruit salad, juice and coffee.",
    "per_person",
    9,
    9,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-breakfast-burrito-fiesta",
    "Breakfast burrito fiesta",
    "Build-your-own breakfast burritos with fruit, juice and coffee.",
    "per_person",
    12,
    12,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-hot-breakfast-buffet",
    "Hot breakfast buffet",
    "Eggs, bacon, sausage, potatoes, fruit, muffins, juice and coffee.",
    "per_person",
    13,
    13,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-deluxe-hot-breakfast",
    "Deluxe hot breakfast buffet",
    "Pancakes or French toast, eggs, meats, potatoes, fruit, muffins and beverages.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-belgian-waffle-bar",
    "Belgian waffle bar",
    "Waffles and toppings with eggs, potatoes, juice and coffee.",
    "per_person",
    13,
    13,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Breakfast & Brunch",
    "mhc-grab-go-breakfast-burrito",
    "Grab-and-go breakfast burrito",
    "Wrapped breakfast burrito with bottled juice and hot sauce.",
    "per_person",
    6,
    6,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Boxed Meals & Lunch",
    "mhc-sandwich-box",
    "Sandwich box lunch",
    "Sandwich with chips and a sweet treat.",
    "per_person",
    10.5,
    10.5,
    30,
    null,
    null,
    null,
    null,
    true,
    "Drop-off only; the published menu adds a 10% delivery fee."
  ],
  [
    "mhc",
    "Boxed Meals & Lunch",
    "mhc-entree-salad-box",
    "Entrée salad box lunch",
    "Entrée salad with chips and a sweet treat.",
    "per_person",
    10.5,
    10.5,
    30,
    null,
    null,
    null,
    null,
    true,
    "Drop-off only; the published menu adds a 10% delivery fee."
  ],
  [
    "mhc",
    "Boxed Meals & Lunch",
    "mhc-gourmet-wrap-box",
    "Gourmet wrap box lunch",
    "Gourmet wrap with chips and a sweet treat.",
    "per_person",
    12,
    12,
    30,
    null,
    null,
    null,
    null,
    true,
    "Drop-off only; the published menu adds a 10% delivery fee."
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-soup-salad-buffet",
    "Soup and salad buffet",
    "Two soups, salads, rolls and butter.",
    "per_person",
    13,
    13,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-salad-bar",
    "Salad bar",
    "Greens, chicken, vegetables, cheeses, dressings, pasta salad and rolls.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-salads-wraps",
    "Salads and wraps buffet",
    "Three salads, wrap halves, chips, cookies and brownies.",
    "per_person",
    14,
    14,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-light-luncheon",
    "Light luncheon",
    "Mini croissant sandwiches, salads, chips, cookies and brownies.",
    "per_person",
    10,
    10,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-enchilada-casserole",
    "Enchilada casserole buffet",
    "Two enchilada casseroles with rice, beans, chips, salsa and salad.",
    "per_person",
    14,
    14,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-fajita-bar",
    "Beef and chicken fajita bar",
    "Fajitas, tortillas, toppings, rice, beans, chips and salsa.",
    "per_person",
    17,
    17,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-bbq-chicken-pork",
    "BBQ chicken and pork buffet",
    "BBQ chicken and pork with buns, beans, chips, salads and fruit.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-burgers-dogs-brats",
    "Hamburgers, hot dogs and brats",
    "Grilled entrées with buns, beans, chips, salads, fruit and toppings.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-hawaiian-menu",
    "Hawaiian menu",
    "Kahlua pork with rice pilaf, fruit, coleslaw and rolls.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-italian-dinner",
    "Italian dinner",
    "Baked ziti or spaghetti, sauces, salad and breadsticks.",
    "per_person",
    12,
    12,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Buffets & Plated Meals",
    "mhc-lasagna",
    "Lasagna buffet",
    "Meat or vegetable lasagna with salad and breadsticks.",
    "per_person",
    16,
    16,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Food Stations & Specialty",
    "mhc-potato-bar",
    "Loaded potato bar",
    "Baked potato with chili, cheese, sour cream, butter and bacon plus salad.",
    "per_person",
    10,
    10,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Food Stations & Specialty",
    "mhc-taco-bar",
    "Taco bar",
    "Beef and chicken tacos with toppings, rice, beans, chips, salsa and salad.",
    "per_person",
    15,
    15,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Food Stations & Specialty",
    "mhc-nacho-bar",
    "Nacho bar",
    "Tortilla chips, queso, beef, toppings, beans, salsa and salad.",
    "per_person",
    13,
    13,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Food Stations & Specialty",
    "mhc-hot-dog-bar",
    "Hot dog bar",
    "Hot dogs, buns, beans, potato salad, chips and toppings.",
    "per_person",
    14,
    14,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-vegetable-tray",
    "Vegetable tray",
    "Fresh vegetables with ranch.",
    "per_person",
    2.5,
    2.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-fruit-salad",
    "Seasonal fruit salad",
    "Seasonal fresh fruit.",
    "per_person",
    2.5,
    2.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-cheese-crackers",
    "Cheese and cracker tray",
    "Mixed cheeses and crackers.",
    "per_person",
    2.5,
    2.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-chips-salsa",
    "Chips and salsa",
    "Tortilla chips with salsa.",
    "per_person",
    1.5,
    1.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-shrimp-cocktail",
    "Shrimp cocktail",
    "Chilled shrimp cocktail.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-hummus-pita",
    "Hummus with pita chips",
    "Hummus dip and pita chips.",
    "per_person",
    2.25,
    2.25,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-mini-sandwiches",
    "Ham and turkey mini sandwiches",
    "Mini sandwiches with ham and turkey.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-spinach-artichoke",
    "Spinach and artichoke dip",
    "Hot spinach and artichoke dip.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-queso-dip",
    "Queso dip",
    "Warm queso dip.",
    "per_person",
    2.25,
    2.25,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-meatballs",
    "Cocktail meatballs",
    "Swedish, barbecue or sweet-and-sour meatballs.",
    "per_person",
    2.5,
    2.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-stuffed-mushrooms",
    "Sausage-stuffed mushrooms",
    "Hot mushrooms filled with sausage.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-chicken-wings",
    "Chicken wings",
    "Barbecue or hot chicken wings.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-petite-quiches",
    "Petite quiches",
    "Assorted petite quiches.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-mini-sausages",
    "Mini sausages",
    "Plain or barbecue mini sausages.",
    "per_person",
    2.25,
    2.25,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-appetizer-bundle-1",
    "Appetizer bundle 1",
    "Vegetable tray, fruit salad, and cheese and crackers.",
    "per_person",
    7,
    7,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-appetizer-bundle-2",
    "Appetizer bundle 2",
    "Bundle 1 plus ham and turkey mini sandwiches.",
    "per_person",
    10,
    10,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-appetizer-bundle-3",
    "Appetizer bundle 3",
    "Vegetable, fruit and cheese trays plus meatballs and spinach-artichoke dip.",
    "per_person",
    11.75,
    11.75,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Appetizers & Receptions",
    "mhc-appetizer-bundle-4",
    "Appetizer bundle 4",
    "Vegetable, fruit and cheese trays plus shrimp cocktail and mini sandwiches.",
    "per_person",
    12.5,
    12.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Snacks & Meeting Breaks",
    "mhc-nuts-pretzels",
    "Mixed nuts and pretzels",
    "Meeting-break mix of nuts and pretzels.",
    "per_person",
    1.5,
    1.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Desserts & Sweets",
    "mhc-cookies-brownies",
    "Cookies and brownies",
    "Cookies, brownies, or a mix.",
    "per_person",
    2,
    2,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Desserts & Sweets",
    "mhc-cheesecake-variety",
    "Cheesecake variety",
    "Assorted cheesecake desserts.",
    "per_person",
    3,
    3,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "mhc",
    "Non-Alcoholic Beverages",
    "mhc-drinks",
    "Iced tea and lemonade or canned drinks",
    "Choose bulk tea and lemonade or canned soda and bottled water.",
    "per_person",
    1.5,
    1.5,
    30,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Breakfast & Brunch",
    "three-tomatoes-cold-breakfast",
    "Cold breakfast buffet",
    "Breakfast breads, granola bars, fruit and yogurt parfaits.",
    "per_person",
    14.75,
    14.75,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Breakfast & Brunch",
    "three-tomatoes-hot-breakfast",
    "Hot breakfast buffet",
    "Vegetable frittata, chicken sausage, fruit, potato hash and breads.",
    "per_person",
    16.25,
    16.25,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Breakfast & Brunch",
    "three-tomatoes-brunch",
    "Brunch buffet",
    "Chicken, frittata, salad, asparagus, fruit and breakfast breads.",
    "per_person",
    18.25,
    18.25,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-fiesta",
    "Fiesta buffet",
    "Chicken and vegetable street tacos with sides, chips, salsa and guacamole.",
    "per_person",
    15.5,
    15.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-barbecue",
    "Barbecue buffet",
    "Choice of barbecue meats with muffins, macaroni, slaw and salad.",
    "per_person",
    16.5,
    16.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-pasta",
    "Pasta buffet",
    "Penne, lasagna, sausage and peppers, salad, vegetables and breadsticks.",
    "per_person",
    17.25,
    17.25,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-stuffed-chicken",
    "Stuffed chicken breast buffet",
    "Stuffed chicken with salad, vegetables, potatoes and rolls.",
    "per_person",
    17.5,
    17.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-short-rib",
    "Braised beef short rib buffet",
    "Braised short rib with salad, vegetables, potatoes and rolls.",
    "per_person",
    18.25,
    18.25,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-beef-salmon",
    "Beef and salmon buffet",
    "Short rib and salmon with salad, carrots, risotto cakes and rolls.",
    "per_person",
    23.75,
    23.75,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-chicken-salmon",
    "Chicken and salmon buffet",
    "Stuffed chicken and salmon with salad, asparagus and risotto cakes.",
    "per_person",
    20,
    20,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-chicken-beef",
    "Chicken and beef buffet",
    "Roasted chicken and short rib with salad, asparagus and potatoes.",
    "per_person",
    20.5,
    20.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Buffets & Plated Meals",
    "three-tomatoes-dietary",
    "Dietary buffet",
    "Plant-forward salad, vegetables, potatoes and rice noodles.",
    "per_person",
    17.75,
    17.75,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Appetizers & Receptions",
    "three-tomatoes-happy-hour",
    "Happy hour buffet",
    "Choose five displayed small bites, boards or sliders.",
    "per_person",
    11.5,
    11.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "three-tomatoes",
    "Appetizers & Receptions",
    "three-tomatoes-hors-doeuvres",
    "Three hors d'oeuvres add-on",
    "Choose three hors d'oeuvres with a qualifying buffet.",
    "per_person",
    6,
    6,
    1,
    null,
    null,
    null,
    null,
    true,
    "Published as a buffet-menu add-on."
  ],
  [
    "three-tomatoes",
    "Desserts & Sweets",
    "three-tomatoes-dessert",
    "Buffet dessert add-on",
    "Choose a handheld s'more, Sweet Tooth assortment, or dessert shots.",
    "per_person",
    2,
    2,
    1,
    null,
    null,
    null,
    null,
    true,
    "Published as a buffet-menu add-on."
  ],
  [
    "brothers",
    "Buffets & Plated Meals",
    "brothers-two-meat",
    "Two-meat combo",
    "Two meats, three sides, buns, sauces, disposables, delivery and setup.",
    "per_person",
    16.99,
    16.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Buffets & Plated Meals",
    "brothers-three-meat",
    "Three-meat combo",
    "Three meats, three sides, buns, sauces, disposables, delivery and setup.",
    "per_person",
    17.99,
    17.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Buffets & Plated Meals",
    "brothers-two-meat-ribs",
    "Two-meat combo plus ribs",
    "Two meats plus ribs, three sides, buns, sauces, delivery and setup.",
    "per_person",
    18.99,
    18.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Buffets & Plated Meals",
    "brothers-three-meat-ribs",
    "Three-meat combo plus ribs",
    "Three meats plus ribs, three sides, buns, sauces, delivery and setup.",
    "per_person",
    19.99,
    19.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Buffets & Plated Meals",
    "brothers-slider-package",
    "BBQ slider package",
    "Two sliders, coleslaw, chips, sauces, disposables, delivery and setup.",
    "per_person",
    12.99,
    12.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Appetizers & Receptions",
    "brothers-veggie-tray",
    "Vegetable tray",
    "Vegetable platter.",
    "per_person",
    3,
    3,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Appetizers & Receptions",
    "brothers-fruit-tray",
    "Fruit tray",
    "Fruit platter.",
    "per_person",
    3,
    3,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Appetizers & Receptions",
    "brothers-cheese-crackers",
    "Cheese and crackers platter",
    "Cheese and cracker platter.",
    "per_person",
    3,
    3,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Snacks & Meeting Breaks",
    "brothers-jalapenos-pickles-onions",
    "Jalapeños, pickles and onions",
    "Condiment and snack tray.",
    "per_person",
    1,
    1,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Desserts & Sweets",
    "brothers-cookies-brownies",
    "Cookies and brownies",
    "Assorted cookies and brownies.",
    "per_person",
    1.99,
    1.99,
    1,
    199,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Desserts & Sweets",
    "brothers-banana-pudding-half",
    "Half-pan banana pudding",
    "Homemade banana pudding; vendor lists 10–15 servings.",
    "per_unit",
    24.99,
    24.99,
    1,
    199,
    "half pan",
    10,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Desserts & Sweets",
    "brothers-banana-pudding-full",
    "Full-pan banana pudding",
    "Homemade banana pudding; vendor lists 20–30 servings.",
    "per_unit",
    49.99,
    49.99,
    1,
    199,
    "full pan",
    20,
    null,
    true,
    ""
  ],
  [
    "brothers",
    "Non-Alcoholic Beverages",
    "brothers-water-soda",
    "Bottled water or canned soda",
    "One bottled water or canned Pepsi product per guest.",
    "per_item",
    2.25,
    2.25,
    1,
    199,
    "drink",
    null,
    1,
    true,
    ""
  ],
  [
    "brothers",
    "Staffing, Delivery & Rentals",
    "brothers-works-upgrade",
    "The Works service upgrade",
    "Tables, linens, chafers, staffed buffet, tea, lemonade and cleanup.",
    "per_person",
    4,
    4,
    50,
    199,
    null,
    null,
    null,
    false,
    "Available only with a qualifying Brothers BBQ catering package."
  ],
  [
    "brothers",
    "Bar & Alcohol Service",
    "brothers-bar-service",
    "Beer and wine bar service",
    "Two hours of beer-and-wine bar service.",
    "per_person",
    5,
    5,
    1,
    199,
    null,
    null,
    null,
    true,
    "Alcohol is limited to beer and wine; vendor policies apply."
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-corporate-box",
    "Corporate box lunch",
    "Sandwich, side salad, chips and dessert.",
    "per_person",
    17.59,
    17.59,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-small-deli",
    "Small deli box",
    "Sandwich, side salad and dessert.",
    "per_person",
    14.39,
    14.39,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-deli-box",
    "Deli box lunch",
    "Sandwich, green or larger side salad, and dessert.",
    "per_person",
    16.19,
    16.19,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-gift-box",
    "Gift box lunch",
    "Sandwich, side salad, chips, fruit, dessert and mint.",
    "per_person",
    21.29,
    21.29,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-classic-box",
    "Classic box lunch",
    "Classic wedge sandwich with chips or grapes.",
    "per_person",
    12.49,
    12.49,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "etais",
    "Boxed Meals & Lunch",
    "etais-sandwich-only",
    "Sandwich only",
    "Sandwich without a side or dessert.",
    "per_person",
    11.89,
    11.89,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Breakfast & Brunch",
    "bagel-deli-lox-tray",
    "Lox, bagel and cream cheese tray",
    "Lox, bagels and cream cheese with coleslaw or seasonal fruit.",
    "per_person",
    21.95,
    21.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Boxed Meals & Lunch",
    "bagel-deli-box-lunch",
    "Box lunch",
    "Sandwich, salad, fruit and dessert.",
    "per_person",
    20.95,
    20.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Boxed Meals & Lunch",
    "bagel-deli-half-sandwich-box",
    "Half-sandwich box lunch",
    "Half sandwich, salad, fruit and dessert.",
    "per_person",
    18.95,
    18.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-deluxe-meat-tray",
    "Deluxe meat tray",
    "Meat, cheese, relish, salad and bread.",
    "per_person",
    20.95,
    20.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-cocktail-meat-tray",
    "Cocktail meat tray",
    "A lighter meat, cheese and relish tray.",
    "per_person",
    18.95,
    18.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-fish-tray",
    "Fish tray",
    "Smoked salmon, salads, bagels, cream cheese and vegetables.",
    "per_person",
    22.95,
    22.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-fresh-fruit-tray",
    "Fresh fruit tray",
    "Seasonal fruit tray.",
    "per_person",
    8.95,
    8.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-cheese-fruit-tray",
    "Cheese and fresh fruit tray",
    "Cheese paired with fresh fruit.",
    "per_person",
    11.95,
    11.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-cheese-tray",
    "Cheese tray",
    "Assorted cheeses with crackers or bagel chips.",
    "per_person",
    9.95,
    9.95,
    15,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-appetizer-tray",
    "Appetizer tray",
    "Chopped liver, egg salad, salami and cheese with relishes.",
    "per_person",
    16.95,
    16.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-sandwich-tray",
    "Full-size sandwich tray",
    "Sandwich halves with salad and relishes.",
    "per_person",
    19.95,
    19.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-relish-tray",
    "Traditional relish tray",
    "Pickles, pickled tomatoes, olives and peppers.",
    "per_person",
    9.95,
    9.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Appetizers & Receptions",
    "bagel-deli-vegetable-dip-tray",
    "Fresh vegetables with dip",
    "Assorted vegetables and dressing dip.",
    "per_person",
    10.5,
    10.5,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "bagel-deli",
    "Desserts & Sweets",
    "bagel-deli-dessert-tray",
    "Dessert tray",
    "Strudels, cakes, brownies, lemon bars and rugelach.",
    "per_person",
    10.95,
    10.95,
    10,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "spice-room",
    "Buffets & Plated Meals",
    "spice-room-essentials",
    "Essentials package",
    "One appetizer, two entrées, rice and butter naan.",
    "per_person",
    18,
    22,
    20,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "spice-room",
    "Buffets & Plated Meals",
    "spice-room-family-feast",
    "Family Feast package",
    "Pakora, three entrées, rice and butter naan.",
    "per_person",
    21.95,
    21.95,
    20,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "spice-room",
    "Buffets & Plated Meals",
    "spice-room-premium",
    "Premium package",
    "Two appetizers, raita, three entrées, rice, naan, dessert and chafing setup.",
    "per_person",
    25,
    32,
    20,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "spice-room",
    "Buffets & Plated Meals",
    "spice-room-grand-feast",
    "Grand Feast package",
    "Three appetizers, four-plus entrées, biryani, desserts, drinks and setup.",
    "per_person",
    35,
    45,
    20,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "tocabe",
    "Buffets & Plated Meals",
    "tocabe-indian-taco",
    "Indian Taco setup",
    "Frybread with proteins, beans, salsas, toppings and serviceware.",
    "per_person",
    16,
    16,
    15,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "tocabe",
    "Buffets & Plated Meals",
    "tocabe-indigenous-grains",
    "Indigenous Grains setup",
    "Indigenous grains with proteins, beans, salsas, toppings and serviceware.",
    "per_person",
    16,
    16,
    15,
    500,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "el-camino",
    "Food Stations & Specialty",
    "el-camino-nacho-bar",
    "Nacho bar",
    "Chips, salsa, queso, jalapeños, cilantro, pico and chorizo.",
    "per_person",
    10,
    10,
    15,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "el-camino",
    "Food Stations & Specialty",
    "el-camino-taco-bar",
    "Taco bar",
    "Two proteins, tortillas, pico, lettuce, cheese and sour cream.",
    "per_person",
    14,
    14,
    15,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "el-camino",
    "Food Stations & Specialty",
    "el-camino-fajita-bar",
    "Fajita bar",
    "Two proteins, toppings, rice, beans, chips and salsa.",
    "per_person",
    18,
    18,
    15,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "el-camino",
    "Food Stations & Specialty",
    "el-camino-enchilada-bar",
    "Enchilada bar",
    "Choice of enchilada with sauce, chips, salsa, rice and beans.",
    "per_person",
    13,
    13,
    15,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Appetizers & Receptions",
    "risica-charcuterie-small",
    "Small charcuterie",
    "Meats, cheeses, crostini, fruit and olives; serves 4–8.",
    "per_unit",
    75,
    75,
    1,
    null,
    "small board",
    8,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Appetizers & Receptions",
    "risica-charcuterie-medium",
    "Medium charcuterie",
    "Meats, cheeses, crostini, fruit and olives; serves 8–15.",
    "per_unit",
    150,
    150,
    1,
    null,
    "medium board",
    15,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Appetizers & Receptions",
    "risica-charcuterie-large",
    "Large charcuterie",
    "Meats, cheeses, crostini, fruit and olives; serves 30–40.",
    "per_unit",
    300,
    300,
    1,
    null,
    "large board",
    40,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Appetizers & Receptions",
    "risica-white-bean-hummus",
    "White-bean hummus and crudités",
    "Rosemary white-bean hummus with fresh vegetables.",
    "per_person",
    7.5,
    7.5,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Appetizers & Receptions",
    "risica-burrata-bar",
    "Burrata bar",
    "Crostini, tomato-basil salad, prosciutto, artichokes, peppers and olives.",
    "per_person",
    12,
    12,
    1,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Food Stations & Specialty",
    "risica-piadina",
    "Piadina",
    "Choice of three folded Italian flatbread preparations.",
    "per_item",
    14,
    14,
    1,
    null,
    "piadina",
    null,
    1,
    true,
    ""
  ],
  [
    "risica",
    "Food Stations & Specialty",
    "risica-eggplant-parmigiana",
    "Eggplant parmigiana",
    "Roasted eggplant, tomato, mozzarella, Parmigiano and basil; serves 8.",
    "per_unit",
    70,
    70,
    1,
    null,
    "tray",
    8,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-rigatoni",
    "Four-cheese rigatoni",
    "Baked rigatoni with four cheeses.",
    "per_person",
    10,
    10,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-short-ribs",
    "Braised short ribs",
    "Braised short ribs with mascarpone polenta.",
    "per_person",
    18,
    18,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-skirt-steak",
    "Grilled skirt steak",
    "Skirt steak with salsa verde and arugula-fennel salad.",
    "per_person",
    22,
    22,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-salmon",
    "Oven-roasted salmon",
    "Salmon with tarragon butter and vegetable caponata.",
    "per_person",
    14,
    14,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-buffet-three",
    "Risica buffet — choose three",
    "Salad, charcuterie, hummus and three selected hot dishes.",
    "per_person",
    55,
    55,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Buffets & Plated Meals",
    "risica-classico",
    "Classico buffet — choose five",
    "Salad, charcuterie, hummus and five selected dishes.",
    "per_person",
    75,
    75,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Desserts & Sweets",
    "risica-tiramisu",
    "Tiramisu",
    "Classic Italian tiramisu.",
    "per_person",
    9,
    9,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ],
  [
    "risica",
    "Desserts & Sweets",
    "risica-chocolate-pudding",
    "Chocolate pudding",
    "Individual chocolate pudding with cream and raspberries.",
    "per_item",
    3.5,
    3.5,
    1,
    null,
    "pudding",
    null,
    1,
    true,
    ""
  ],
  [
    "risica",
    "Desserts & Sweets",
    "risica-apple-strudel",
    "Apple strudel",
    "Apple strudel with Chantilly cream and berry marmalade.",
    "per_person",
    9,
    9,
    8,
    null,
    null,
    null,
    null,
    true,
    ""
  ]
];

export const FOOD_OPTIONS = FOOD_OPTION_ROWS.map(([
  vendorKey,
  category,
  id,
  offering,
  description,
  basis,
  low,
  high,
  minHeadcount,
  maxHeadcount,
  unitLabel,
  unitCapacity,
  itemsPerGuest,
  surchargeEligible,
  rowNote,
]) => {
  const [vendor, sourceName, sourceNote] = VENDOR_SOURCES[vendorKey];

  return {
    id,
    category,
    vendor,
    offering,
    label: `${vendor} — ${offering}`,
    description,
    basis,
    low,
    high,
    minHeadcount,
    maxHeadcount,
    sourceName,
    capturedOn: '2026-09-25',
    note: [sourceNote, rowNote].filter(Boolean).join(' '),
    ...(unitLabel ? { unitLabel } : {}),
    ...(unitCapacity ? { unitCapacity } : {}),
    ...(itemsPerGuest ? { itemsPerGuest } : {}),
    surchargeEligible: surchargeEligible !== false,
    confidence: 'published',
  };
});

// Keep old shared links working without showing their broad benchmark choices
// in the vendor-specific browser.
export const LEGACY_FOOD_OPTIONS = [
  {
    id: 'light',
    label: 'Coffee & light snacks',
    basis: 'per_person',
    low: 20,
    high: 26,
    confidence: 'benchmark',
    surchargeEligible: true,
    note: 'Legacy selection retained for existing saved quotes.',
  },
  {
    id: 'appetizers',
    label: 'Appetizers',
    basis: 'per_person',
    low: 30,
    high: 55,
    confidence: 'benchmark',
    surchargeEligible: true,
    note: 'Legacy selection retained for existing saved quotes.',
  },
  {
    id: 'lunch',
    label: 'Lunch',
    basis: 'per_person',
    low: 65,
    high: 88,
    confidence: 'benchmark',
    surchargeEligible: true,
    note: 'Legacy selection retained for existing saved quotes.',
  },
  {
    id: 'dinner',
    label: 'Dinner',
    basis: 'per_person',
    low: 115,
    high: 125,
    confidence: 'benchmark',
    surchargeEligible: true,
    note: 'Legacy selection retained for existing saved quotes.',
  },
];

const FOOD_OPTION_LOOKUP = new Map(
  [...FOOD_OPTIONS, ...LEGACY_FOOD_OPTIONS].map((option) => [
    option.id,
    option,
  ])
);

export function foodOptionForId(id) {
  return FOOD_OPTION_LOOKUP.get(id) || null;
}
